import { createDefaultTyrann } from '@apis/common';
import { file, formDataEncoder } from '@utils/types';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const cropDataBody = t.type({
  x: t.number,
  y: t.number,
  width: t.number,
  height: t.number,
});

export type CropDataBody = t.TypeOf<typeof cropDataBody>;

export const avatarApis = createDefaultTyrann({
  '/avatar/': {
    post: {
      body: t.type({
        avatar_data: t.string,
        avatar_file: file(),
      }),
      response: {
        200: t.type({
          state: t.number,
          message: t.string,
          result: t.string,
          result_hd: t.string,
        }),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
      options: {
        bodyEncoder: formDataEncoder,
      },
    },
  },
});
